// Generated by CoffeeScript 1.12.7
(function () {
  Viewthespace.Properties = (function () {
    function Properties() {
      let ref, sum;

      sum = 0;
      $(".top-bar .frame")
        .children()
        .each(function () {
          return (sum += $(this).outerWidth(true));
        });
      if (sum > 940) {
        $(".property").css("min-width", sum + 50);
        $("#top_nav").css("min-width", sum + 50);
      }
      this.initializeViewTabs();
      this.initializeFancybox();
      this.initializeGoogleMaps();
    }

    Properties.prototype.initializeViewTabs = function () {
      let $viewTabs, self;

      self = this;
      $viewTabs = $(".view-tabs li");

      return $viewTabs.each(function (index, element) {
        let $link, $tab, href, isActive;

        $link = $(this);
        isActive = $link.hasClass("active");
        href = $link.children("a").attr("href");
        $tab = $(href);
        if (!isActive) {
          $tab.addClass("tab-hidden");
        }

        return $link.bind("click", function (e) {
          e.preventDefault();
          $viewTabs.removeClass("active");
          $link.addClass("active");
          $(".tab-content").children("div").addClass("tab-hidden");
          $tab.removeClass("tab-hidden");

          if (href === "#map-view" && self.map) {
            self.map.resize();

            return self.map.recenter();
          }
        });
      });
    };

    Properties.prototype.initializeFancybox = function () {
      $(".lightbox").fancybox();

      return new Viewthespace.AjaxFormModal();
    };

    Properties.prototype.initializeGoogleMaps = function () {
      let $mapCanvas, latitude, longitude, self;

      self = this;
      $mapCanvas = $("#map_canvas");
      latitude = $mapCanvas.data("latitude");
      longitude = $mapCanvas.data("longitude");

      return new Viewthespace.Map(latitude, longitude, null, function (map) {
        map.addMarker(latitude, longitude);

        return (self.map = map);
      });
    };

    return Properties;
  })();
}.call(this));
